import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';
import tokenIcon from './assets/token-icon.svg';

import './styles.css';

const TokenField = ({
  input: {onChange, onBlur, value},
  placeholder,
  className,
  disabled,
  meta: {touched, error}
}: any) => {
  return (
    <div className="TokenField">
      <div className="inputWrapper">
        <div className="icon">
          <img src={tokenIcon} alt="Email icon" />
        </div>
        <input
          onChange={onChange}
          onBlur={onBlur}
          className={classNames({error: touched && error, disabled}, className)}
          placeholder={placeholder}
          type="text"
          value={value}
          disabled={disabled}
        />
      </div>
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default TokenField;
